import { strategicPlanningApi } from "@/api/strategicPlanningApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import Loading from "@/components/feedback/Loading";
import StrategicPlanStatus from "@/components/plan/StrategicPlanStatus";
import {
    StrategicPlanningActionPlanIcon,
    StrategicPlanningGoalIcon,
    StrategicPlanningIcon,
    StrategicPlanningObjectiveIcon,
} from "@/config";
import { Avatar, Box, Chip, Container, Divider, Tab, Tabs, Typography } from "@mui/material";
import { Outlet, useParams } from "react-router-dom";

export default function StrategicPlanningViewerLayout() {
    const { strategicPlanningId } = useParams();

    const getStrategicPlanning = strategicPlanningApi.endpoints.getPlanById.useQuery({
        id: strategicPlanningId,
    });
    const strategicPlanning = getStrategicPlanning.data?.data;
    const isLoading = getStrategicPlanning.isLoading;

    return (
        <>
            <Container>
                <Breadcrumbs
                    items={[
                        {
                            label: "Strategic Planning",
                            to: "/workspace/strategic-plannings",
                        },
                        { label: `#${strategicPlanningId}` },
                    ]}
                />
            </Container>

            <Container>
                <Box sx={{ display: "flex", marginTop: 1 }}>
                    <Box sx={{ marginRight: 2 }}>
                        <Avatar
                            variant="rounded"
                            color="secondary"
                            sizes="54"
                            sx={{ width: 54, height: 54, marginTop: 1 }}
                        >
                            <StrategicPlanningIcon />
                        </Avatar>
                    </Box>
                    <Box>
                        <Typography variant="h2" fontSize="1.2em" fontWeight="bold" gutterBottom>
                            {strategicPlanning?.title}
                        </Typography>
                        <Typography variant="h2" fontSize="1em" gutterBottom>
                            {strategicPlanning?.subtitle}
                        </Typography>
                        <Typography variant="h2" fontSize="1em" gutterBottom>
                            {strategicPlanning?.description}
                        </Typography>
                        <Box sx={{ marginY: 1 }}>
                            {!isLoading && <StrategicPlanStatus strategicPlanning={strategicPlanning} />}
                        </Box>
                    </Box>
                </Box>

                <Tabs value={0}>
                    <Tab value={0} label="Information"></Tab>
                    <Tab
                        value={1}
                        label={
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <StrategicPlanningObjectiveIcon fontSize="small" /> Objective
                            </Box>
                        }
                        disabled={true}
                    ></Tab>
                    <Tab
                        value={2}
                        label={
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <StrategicPlanningGoalIcon fontSize="small" /> Goal
                            </Box>
                        }
                        disabled={true}
                    ></Tab>
                    <Tab
                        value={3}
                        label={
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <StrategicPlanningActionPlanIcon fontSize="small" /> Action Plan
                            </Box>
                        }
                        disabled={true}
                    ></Tab>
                </Tabs>
                <Divider />
            </Container>

            {/** content */}
            {isLoading ? <Loading /> : <Outlet context={{ strategicPlanning: strategicPlanning }} />}
        </>
    );
}
